"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCapiClientFormEncoded = exports.createCapiClient = exports.getHeadersFormEncoded = exports.getHeaders = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _logAxiosError = _interopRequireDefault(require("./logAxiosError"));

/**
 * Get axios headers for authenticating with CAPI
 *
 * @param {string} orderingToken - The CAPI authentication token to use
 * @param {string} [sessionID] - (optional) A unique ID for the current user's session with CAPI,
 *      used to track a user across requests
 * @param {string} [applicationID] - (optional) The application ID used for the client's current session.
 * @param {string} [applicationUrl] - (optional) The application URL used for the client's current session.
 * @param {string} [sfVersion] - (optional) The version of the storefront application.
 */
var getHeaders = function getHeaders(orderingToken, sessionID, applicationID, applicationUrl) {
  var sfVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'N/A';
  return {
    Authorization: "Token ".concat(orderingToken),
    'Session-ID': sessionID || '',
    'Application-ID': applicationID,
    'Application-URL': applicationUrl,
    'Storefront-Version': sfVersion
  };
};
/**
 * Get axios headers for authenticating with CAPI, but specify x-www-form-urlencoded content type
 *
 * @param {string} orderingToken - The CAPI authentication token to use
 * @param {string} [sessionID] - (optional) A unique ID for the current user's session with CAPI,
 *      used to track a user across requests
 * @param {string} [applicationID] - (optional) The application ID used for the client's current session.
 * @param {string} [applicationUrl] - (optional) The application URL used for the client's current session.
 * @param {string} [sfVersion] - (optional) The version of the storefront application.
 */


exports.getHeaders = getHeaders;

var getHeadersFormEncoded = function getHeadersFormEncoded(orderingToken, sessionID, applicationID, applicationUrl) {
  var sfVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'N/A';
  var headers = getHeaders(orderingToken, sessionID, applicationID, applicationUrl, sfVersion);
  headers['content-type'] = 'application/x-www-form-urlencoded;charset=utf-8';
  return headers;
};
/**
 * Create a new axios client for sending requests to CAPI
 *
 * @param {string} capiURL - The base URL of CAPi that requests go to, ex: https://capi.cashstar.com
 * @param {string} orderingToken - The ordering token used to identify the client with CAPI.
 *      This should be a 40-character string that CashStar provides out-of-band to the client.
 * @param {string} [sessionID] - (optional) The session ID of the client's current session,
 *      which are generated via the `createNewSession` request.
 * @param {string} [applicationID] - (optional) The application ID used for the client's current session.
 * @param {string} [applicationUrl] - (optional) The application URL used for the client's current session.
 * @param {string} [sfVersion] - (optional) The version of the storefront application.
 * @param {boolean} [logErrors] - (optional) Whether or not to log errors thrown by axios via the built-in logger
 * @returns {AxiosInstance} An axios instance
 */


exports.getHeadersFormEncoded = getHeadersFormEncoded;

var createCapiClientBase = function createCapiClientBase(capiURL, orderingToken, sessionID, applicationID, applicationUrl, getHeadersFunc) {
  var sfVersion = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'N/A';
  var logErrors = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var headers = getHeadersFunc(orderingToken, sessionID, applicationID, applicationUrl, sfVersion);

  var client = _axios.default.create({
    baseURL: capiURL,
    headers: headers
  }); // For now we can ignore this linting about unnecessary block statements

  /* eslint arrow-body-style: 0 */


  client.interceptors.response.use(function (response) {
    // Trim the axios fat
    return response.data;
  }, function (error) {
    if (logErrors) {
      (0, _logAxiosError.default)(error);
    }

    return Promise.reject(error);
  });
  return client;
};

var createCapiClient = function createCapiClient(capiURL, orderingToken, sessionID, applicationID, applicationUrl) {
  var sfVersion = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'N/A';
  var logErrors = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  return createCapiClientBase(capiURL, orderingToken, sessionID, applicationID, applicationUrl, getHeaders, sfVersion, logErrors);
};

exports.createCapiClient = createCapiClient;

var createCapiClientFormEncoded = function createCapiClientFormEncoded(capiURL, orderingToken, sessionID, applicationID, applicationUrl) {
  var sfVersion = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'N/A';
  var logErrors = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  return createCapiClientBase(capiURL, orderingToken, sessionID, applicationID, applicationUrl, getHeadersFormEncoded, sfVersion, logErrors);
};

exports.createCapiClientFormEncoded = createCapiClientFormEncoded;